<template>
  <div>
		<!-- <calendar></calendar> -->
	
		<div style="height:100vh">
			<iframe 
		:src="src" 
		width="100%" height="1500px" scrolling="no" frameborder="0"

		></iframe>
		</div>
	</div>
</template>

<script>
// import calendar from "../../../components/calendar";
export default {
  data() {
    return {
			src:''
		};
  },
	components: {
		// calendar
	},
	created(){
		this.src="https://www.bmcx.com/apiiframe/?api_from=bmcx&api_url=https://wannianrili.bmcx.com/&api_width=98%&api_backgroundcolor=FFFFFF&api_navigation=no"
	},
	methods: {
		loadfrom (val) {
      // console.log(val.path[0].contentWindow.location)
      // console.log(val.path[0].contentWindow.location.href)
      // http://localhost:8080/static/yunyaopai4.0/index.html
      let url = val.path[0].contentWindow.location.href
      let urlArr = url.split('/')
      let urlArrLength = urlArr.length
      if (urlArr[urlArrLength - 1] === 'index.html' && urlArr[urlArrLength - 2] === 'yunyaopai4.0') {
        // console.log('ok')
        // console.log(this.$router)
        this.$router.push('/live')
      }
    }
	}
};
</script>
<style scoped>

.iframe {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    overflow-y: hidden;
}
</style>